import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import { HttpSuccessCodes } from 'src/Member/errorhandling/HttpErrorCodes';
import ToastMessage from '../../common/ToastMessage';

const useAccountUnlockOtp = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const timerRef = useRef(null);
  const headingRef = useRef(null);

  const data = location.state?.data;
  const emailID = data?.UserEmail;

  console.log('aaaa----', data);

  const [verifyOTPCodeLoader, setVerifyOTPCodeLoader] = useState(false);
  const [generateOTPLoader, setGenerateOTPLoader] = useState(false);
  const [canResend, setCanResend] = useState(false);
  const [validOTPAttempts, setValidOTPAttempts] = useState(0);
  const [otpAttempts, setOtpAttempts] = useState(0);
  const [otpLength, setOtpLength] = useState(6);
  const [otpExpiryTimeout, setOtpExpiryTimeout] = useState(300);
  const [configLoading, setConfigLoading] = useState(true);
  const [isOTPBlocked, setIsOTPBlocked] = useState(false);
  const [isgenerateOtpError, setIsGenerateOtpError] = useState(false);

  const getOTPConfig = async () => {
    try {
      setConfigLoading(true);

      const response = await axiosInstance.get(
        APIEndpoints.getAdminConfigResources(),
      );

      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        const { OTPLength, OTPExpiresIn, InvalidOTPAttempts } =
          response.data.Response.InsurerClientSettings;

        setOtpLength(OTPLength);
        setOtpAttempts(InvalidOTPAttempts);
        setOtpExpiryTimeout(parseInt(OTPExpiresIn || 5) * 60);
      }
    } catch (error) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Unable to load OTP configuration."
        />,
      );
    } finally {
      setConfigLoading(false);
    }
  };

  const timer = (remaining) => {
    clearTimeout(timerRef.current);

    let s = remaining % 60;
    let m = Math.floor(remaining / 60);

    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;

    const element = document.getElementById('otp-timer');

    if (element) element.innerHTML = m + ':' + s;

    remaining -= 1;

    if (remaining >= 0) {
      timerRef.current = setTimeout(() => {
        timer(remaining);
      }, 1000);
      if (remaining === 0) {
        setCanResend(true);
      }

      return;
    }
  };

  const sendOTPRequest = async () => {
    try {
      setIsGenerateOtpError(false);
      setGenerateOTPLoader(true);
      setCanResend(false);
      const response = await axiosInstance.get(
        `${APIEndpoints.getOtpGenerateResources()}${emailID}`,
      );

      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response.status) {
        timer(otpExpiryTimeout);
      }
      //else setGenerateOTPCodeLoader(false);
    } catch (error) {
      setIsGenerateOtpError(true);
      console.error(error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle={t('member.pages.my_profile.otp.otp_regenerate_error')}
        />,
      );
    } finally {
      setGenerateOTPLoader(false);
    }
  };

  const verifyOTPCode = async (values, setFieldError) => {
    if (validOTPAttempts >= otpAttempts) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle="You have exceeded the maximum OTP attempts. Please try again later."
        />,
      );
      return;
    }
    try {
      setVerifyOTPCodeLoader(true);

      const response = await axiosInstance.get(
        `${APIEndpoints.getOtpVerifyResources()}${
          values.otp
        }/userid/${emailID}`,
      );

      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response.status) {
        if (data?.ResetPassword) {
          navigate('/member/account-unlock-reset-password', {
            state: {
              data,
            },
          });
        } else {
          navigate('/member/account-unlock-success', {
            state: {
              data: data,
              OTPRequired: true,
              forcePassword: false,
            },
          });
        }
      }
    } catch (error) {
      const errorCode = error?.response?.status;

      if (errorCode === 400) {
        let failedCount = false;
        let accountLocked = false;
        let errorMessageOTP = '';

        const errorMessage =
          error?.response?.data?.message?.replace(/[\\["\]]/g, '') || '';

        accountLocked = errorMessage.indexOf('Account locked') > -1;

        failedCount = errorMessage.indexOf('Failed count') > -1;

        const currentAttempt = validOTPAttempts + 1;
        console.log('Current Attempt:', currentAttempt);
        console.log('Max Attempts:', otpAttempts);
        setValidOTPAttempts(currentAttempt);

        const pendingAttempts = otpAttempts - currentAttempt;
        console.log('Pending Attempts:', pendingAttempts);

        console.log({
          accountLocked,
          failedCount,
          currentAttempt,
          otpAttempts,
        });

        if (accountLocked || currentAttempt >= otpAttempts) {
          setIsOTPBlocked(true);

          errorMessageOTP =
            'You have exceeded the maximum OTP attempts. Please try again later.';

          toast.error(<ToastMessage type="error" subTitle={errorMessageOTP} />);

          //navigate wherever business wants
          //navigate('/member');
        } else if (failedCount) {
          errorMessageOTP = `Invalid OTP. ${
            pendingAttempts === 0 ? 'Final' : pendingAttempts
          } ${pendingAttempts <= 1 ? 'Attempt' : 'Attempts'} Left.`;
        } else {
          errorMessageOTP = 'Unable to verify your OTP code now.';
        }

        setFieldError('otp', errorMessageOTP);
      } else {
        toast.error(
          <ToastMessage
            type="error"
            subTitle="Unable to verify your OTP code now."
          />,
        );
      }
    } finally {
      setVerifyOTPCodeLoader(false);
    }
  };

  useEffect(() => {
    getOTPConfig();
  }, []);

  useEffect(() => {
    if (emailID && !configLoading && otpExpiryTimeout) {
      sendOTPRequest();
    }
  }, [emailID, configLoading, otpExpiryTimeout]);

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);
  useEffect(() => {
    if (headingRef.current) {
      headingRef.current.focus();
    }
  }, [configLoading]);

  return {
    data,
    otpLength,
    otpAttempts,
    configLoading,
    canResend,
    generateOTPLoader,
    verifyOTPCodeLoader,
    validOTPAttempts,
    sendOTPRequest,
    verifyOTPCode,
    isOTPBlocked,
    headingRef,
    isgenerateOtpError,
  };
};
export default useAccountUnlockOtp;
